import React, { useState, useEffect } from 'react';
import { Typography, Button, Grid } from '@mui/material';
import { Link } from 'react-router-dom';
import DisciplinaCard from '../../components/Disciplinas/DisciplinaCard';
import { listarDisciplinas } from '../../services/disciplinaService';

const ListaDisciplinasPage = () => {
  const [disciplinas, setDisciplinas] = useState([]);

  useEffect(() => {
    const fetchDisciplinas = async () => {
      try {
        const data = await listarDisciplinas();
        setDisciplinas(data);
      } catch (error) {
        console.error('Erro ao buscar disciplinas:', error);
        // TODO: Adicionar tratamento de erro e feedback ao usuário
      }
    };

    fetchDisciplinas();
  }, []);

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Disciplinas
      </Typography>
      <Button
        component={Link}
        to="/disciplinas/criar"
        variant="contained"
        color="primary"
        sx={{ mb: 2 }}
      >
        Adicionar Nova Disciplina
      </Button>
      <Grid container spacing={3}>
        {disciplinas.map((disciplina) => (
          <Grid item key={disciplina.id} xs={12} sm={6} md={4}>
            <DisciplinaCard disciplina={disciplina} />
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default ListaDisciplinasPage;